export const type = [
  { type: 'EX', name: '视觉精细', color: '#ff4d94' },
  { type: 'ST', name: '视觉刺激', color: '#3ECC88' },
  { type: 'MFBF', name: '脱抑制', color: '#00C7FF' },
  { type: 'FU', name: '集合训练', color: '#BF90FF' },
  { type: 'DV', name: '散开训练', color: '#BF90FF' },
  { type: 'SV', name: '同时视', color: '#FE8347' },
  { type: 'STE', name: '立体视', color: '#FCCE19' },
  { type: 'DR', name: '多人训练' },
  { type: 'ACC', name: '调节训练' },
  { type: 'MYO', name: '近视训练' },
  { type: 'EXAM', name: '检查' },
]
